import apiClient from './apiClient'


const getMembers = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/Member/${projectId}`)
}

const getMember = (tenant, projectId, id) => {
  return apiClient.get(`/${tenant}/Member/${projectId}/${id}`)
}

const createMember = (tenant, member) => {
  return apiClient.post(`/${tenant}/Member/${member.projectId}`, member)
}

const updateMember = (tenant, projectId, id, member) => {
  return apiClient.put(`/${tenant}/Member/${projectId}/${id}`, member)
}

const deleteMember = (tenant, projectId, id) => {
  return apiClient.delete(`/${tenant}/Member/${projectId}/${id}`)
}


export default {
  getMembers,
  getMember,
  createMember,
  updateMember,
  deleteMember
}
